import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { MessageI } from '@interfaces/message.interface';
import { PageI } from '@interfaces/page.interface';
import { Observable, firstValueFrom } from 'rxjs';
import { MessageTypeT } from '@omnitypes/message.type';
@Injectable({
  providedIn: 'root',
})
export class MessagesService {
  private slug_url = 'messages';
  private baseUrl = environment.OMNISMART_API_CHAT_PERSISTENCE;
  private slug_message_content = 'update-message-content';

  constructor(private readonly http: HttpClient) {}

  public findByChat(
    id: string,
    page = 1,
    search = '',
    sort = 'desc',
    limit = 50,
    active = 'createdAt',
    types: MessageTypeT[] | null = null
  ): Observable<PageI<MessageI>> {
    const params = new HttpParams()
      .set('search', search)
      .set('sort', sort)
      .set('active', active)
      .set('limit', limit.toString())
      .set('page', page.toString())
      .set('types', types ? JSON.stringify(types) : '');

    return this.http.get<PageI<MessageI>>(`${this.baseUrl}${this.slug_url}/${id}`, {
      params,
    });
  }

  public findScheduled(
    chatId = '',
    page = 1,
    search = '',
    sort = 'desc',
    limit = 50,
    active = 'createdAt',
    types: MessageTypeT[] | null = null
  ): Observable<PageI<MessageI>> {
    const params = new HttpParams()
      .set('chat', chatId)
      .set('search', search)
      .set('sort', sort)
      .set('active', active)
      .set('limit', limit.toString())
      .set('page', page.toString())
      .set('types', types ? JSON.stringify(types) : '');

    return this.http.get<PageI<MessageI>>(`${this.baseUrl}${this.slug_url}/scheduled`, {
      params,
    });
  }

  public updateMessageContent(id: string, content: any): Observable<MessageI> {
    return this.http.patch<MessageI>(`${this.baseUrl}${this.slug_url}/${this.slug_message_content}/${id}`, content);
  }

  public sendEmailMessageSync(message: Partial<MessageI>) {
    return this.http.post(`${this.baseUrl}${this.slug_url}/email-sync`, { message });
  }

  public sendSMSMessage(message: MessageI) {
    return this.http.post(`${this.baseUrl}${this.slug_url}/send-sms`, message);
  }
}
